// پروفایل — the editable profile, appearance, and the way out.
export const profile = {
  // ── profile ──────────────────────────────────────────────────────────
  'profile.title': 'Profile',
  'profile.sections.identity': 'Your details',
  'profile.sections.account': 'Account',
  'profile.sections.appearance': 'Appearance and language',
  'profile.fields.phone': 'Mobile number',
  'profile.fields.studentId': 'Account ID',
  'profile.fields.cases': 'Practice patients',
  'profile.fields.balance': 'Parseh balance',
  'profile.identity.note': 'Your mobile number comes from your Parsina sign-in account and is changed there, not here.',
  'profile.saved': 'Profile saved.',
  'profile.appearance.theme': 'Accent colour',
  'profile.appearance.fontSize': 'Text size',
  'profile.appearance.language': 'Language',
  'profile.appearance.localOnly': 'These are remembered in this browser only — they do not follow you to another device.',
  'profile.theme.default': 'Parsina blue',
  'profile.theme.teal': 'Teal',
  'profile.theme.ocean': 'Ocean',
  'profile.theme.slate': 'Slate blue',
  'profile.fontSize.small': 'Small',
  'profile.fontSize.medium': 'Medium',
  'profile.fontSize.large': 'Large',
  'profile.language.fa': 'فارسی',
  'profile.language.en': 'English',
  'profile.logout': 'Sign out',
};

export default profile;
